var map = {
	"./icon-gp-128x128-01-nested.svg": "1227",
	"./icon-gp-128x128-02-tree.svg": "0a8e",
	"./icon-gp-128x128-03-star.svg": "d2b7",
	"./icon-gp-128x128-04-ribbon.svg": "37b0",
	"./icon-gp-128x128-05-flag.svg": "e34eb",
	"./icon-gp-128x128-06-pin.svg": "512b",
	"./icon-gp-128x128-07-exclaim.svg": "c680",
	"./icon-gp-128x128-08-eye.svg": "fa8f",
	"./icon-gp-128x128-09-button.svg": "56b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ac4";